import { GET_LIST, GET_MANY } from 'react-admin';

const getPackageTypes = ({ response, url, options, httpClient, params, apiUrl }) => ({
  ...response,
  json: response.json.map((item) => ({
    ...item,
    id: item.code,
  })),
});

export default {
  [GET_LIST]: getPackageTypes,
  [GET_MANY]: getPackageTypes,
};
